import { BaseInterior } from '../BaseInterior';
import { socketManager, CasinoInfo } from '../../socket/SocketManager';

type CasinoView = 'LOBBY' | 'SLOTS' | 'BLACKJACK' | 'ROULETTE' | 'CRAPS' | 'MANAGEMENT';

export class CasinoLobby {
  constructor(
    private interior: BaseInterior,
    private scene: Phaser.Scene,
    private graphics: Phaser.GameObjects.Graphics,
    private building: any,
    private stateData: any,
    private onNavigate: (view: CasinoView) => void,
  ) {}

  render(): void {
    const { width: W, height: H } = this.scene.scale;
    const cx = W / 2;
    const casinoInfo: CasinoInfo | undefined = this.stateData?.casinoInfo;
    console.log(`[CASINO] Lobby render, casinoInfo=${casinoInfo ? JSON.stringify({ stars: casinoInfo.stars, attendance: casinoInfo.attendance, ownerId: casinoInfo.ownerId }) : 'undefined'}`);

    // Title with stars
    const stars = casinoInfo?.stars || 1;
    const starText = this.getStarDisplay(stars);
    (this.interior as any).addTitle(`${this.building.name}  ${starText}`);

    // Visitor count
    const infoY = H * 0.16;
    (this.interior as any).addLabel(cx - W * 0.12, infoY, `Visiteurs: ${casinoInfo?.attendance || 0}`, '#cccccc', '16px');

    // Owner info
    const ownerText = casinoInfo?.ownerId ? 'Proprietaire actif' : 'Disponible';
    (this.interior as any).addLabel(cx + W * 0.06, infoY, ownerText, '#aaaaaa', '14px');

    // 2x2 game grid — centered and scaled
    const cardW = Math.min(W * 0.2, 160);
    const cardH = Math.min(H * 0.14, 100);
    const gap = Math.min(W * 0.025, 20);

    const gridW = 2 * cardW + gap;
    const gridStartX = cx - gridW / 2;
    const gridStartY = H * 0.24;

    const games: { name: string; view: CasinoView; color: number }[] = [
      { name: 'Machines a sous', view: 'SLOTS', color: 0xe6b800 },
      { name: 'Blackjack', view: 'BLACKJACK', color: 0x2d8f2d },
      { name: 'Roulette', view: 'ROULETTE', color: 0xc0392b },
      { name: 'Craps', view: 'CRAPS', color: 0x2980b9 },
    ];

    games.forEach((game, i) => {
      const col = i % 2;
      const row = Math.floor(i / 2);
      const x = gridStartX + col * (cardW + gap);
      const y = gridStartY + row * (cardH + gap);

      // Card background
      this.graphics.fillStyle(game.color, 0.3);
      this.graphics.fillRoundedRect(x, y, cardW, cardH, 10);
      this.graphics.lineStyle(2, game.color, 0.8);
      this.graphics.strokeRoundedRect(x, y, cardW, cardH, 10);

      // Game name
      const nameFontSize = Math.max(12, Math.round(cardW * 0.1)) + 'px';
      (this.interior as any).addLabel(x + cardW * 0.1, y + cardH * 0.15, game.name, '#ffffff', nameFontSize);

      // "Entrer" button
      const hexColor = `#${game.color.toString(16).padStart(6, '0')}`;
      (this.interior as any).addButton(x + cardW / 2, y + cardH - cardH * 0.25, 'Entrer', hexColor, () => {
        console.log(`[CASINO] Game button clicked: ${game.name} -> ${game.view}`);
        this.onNavigate(game.view);
      });
    });

    // Management button (owner only)
    const playerId = socketManager.getPlayerId();
    if (casinoInfo?.ownerId && casinoInfo.ownerId === playerId) {
      (this.interior as any).addButton(
        cx,
        gridStartY + 2 * (cardH + gap) + H * 0.03,
        'GESTION',
        '#7b2fbe',
        () => {
          console.log(`[CASINO] Management button clicked`);
          this.onNavigate('MANAGEMENT');
        },
      );
    }
  }

  private getStarDisplay(stars: number): string {
    const full = Math.min(5, Math.floor(stars));
    const empty = 5 - full;
    return String.fromCharCode(9733).repeat(full) + String.fromCharCode(9734).repeat(empty) + (stars > 5 ? '+' : '');
  }
}
